'use es6';

import Client from 'AdsUI/data/Client';
export function getAccountHasBusinessManager(accountId) {
  const url = `ads/v1/facebook/account/${accountId}/has-business-manager`;
  return Client.apiRequest(url);
}
export function overrideEngagementLimitForAd(accountId, adId) {
  const url = `ads/v1/tracking/facebook/account/${accountId}/ad/${adId}`;
  return Client.apiRequest(url, {
    type: 'PUT'
  });
}